import React from 'react';
import { Illustration, IconName } from '@klp/design/Illustrations';

export function ProsjektAvfallSortert({
    sortert,
}: {
    sortert: boolean | null;
}) {
    if (sortert === null) return null;

    return sortert ? (
        <Illustration icon={IconName.CHECK} klpPalette="secondary" />
    ) : (
        <Illustration icon={IconName.CLOSE} klpPalette="primary" />
    );
}
